module.exports = __webpack_public_path__ + "img/learnapp_tablet1@2x.9b765485.png";